export const getAccessToken = () => {
  return localStorage.getItem("token");
};

export const getRefreshToken = () => {
  return localStorage.getItem("refreshToken");
};

export const setTokens = (token: string, refreshToken: string) => {
  localStorage.setItem("token", token);
  localStorage.setItem("refreshToken", refreshToken);
};

export const getUsername = () => {
  const username = localStorage.getItem("username");
  return username ?? "";
};

export const setUsername = (s: string) => {
  localStorage.setItem("username", s);
};
